/* unplugin-vue-components disabled */import script from "./Stsg.vue?vue&type=script&lang=ts&setup=true"
export * from "./Stsg.vue?vue&type=script&lang=ts&setup=true"

import "./Stsg.vue?vue&type=style&index=0&id=55e4a764&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e4a764"]])

export default __exports__